export class InvalidArgumentError extends Error {
    constructor(name, msg) {
        super(msg);
        this.name = name;
        this.message = msg;
    }
}
